import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import Marquee from './ui/Marquee';
import { cn } from '../lib/cn';
import boopImage from '../assets/images/boop.jpg';

const NAV = [
  { to: '/buy', label: 'Buy' },
  { to: '/memefi', label: 'MemeFi' },
  { to: '/games', label: 'Games' },
  { to: '/#how', label: 'How to BOOP' },
  { to: '/#faq', label: 'FAQ' },
];

const navClass = ({ isActive }, extra) =>
  cn(
    'rounded-full border-2 px-3 py-1 text-[15px] font-semibold no-underline transition',
    isActive ? 'border-ink bg-sun' : 'border-transparent hover:border-ink hover:bg-paper',
    extra
  );

const Header = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname, location.hash]);

  // Hash links ("/#faq") should not light up as the active page.
  const isHash = (to) => to.includes('#');

  return (
    <>
      <header className="sticky top-0 z-50 border-b-[3px] border-ink bg-cream/95 backdrop-blur-md">
        <div className="wrap flex items-center gap-2.5 py-2">
          <Link to="/" className="flex shrink-0 items-center gap-2.5 no-underline" aria-label="BOOP home">
            <img src={boopImage} alt="BOOP mascot" className="h-10 w-10 rounded-full border-[3px] border-ink bg-white object-cover" width={40} height={40} />
            <span className="text-[22px] font-bold tracking-[1px]">BOOP</span>
          </Link>

          <nav className="ml-6 hidden items-center gap-1 lg:flex" aria-label="Main">
            {NAV.map((item) => (
              <NavLink key={item.to} to={item.to} end className={(s) => navClass(isHash(item.to) ? { isActive: false } : s)}>
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="ml-auto flex items-center gap-1.5">
            <span className="chip max-[379px]:hidden">
              <span className="h-2 w-2 rounded-full border border-ink bg-sun" aria-hidden="true" />
              ARB
            </span>
            <span className="chip max-[379px]:hidden">
              <span className="h-2 w-2 rounded-full border border-ink bg-blush" aria-hidden="true" />
              SOL
            </span>
          </div>
          <Link className="btn btn-sm" to="/buy">
            Buy
          </Link>
          <button
            type="button"
            className="btn btn-paper btn-sm !px-2.5 lg:hidden"
            aria-label={open ? 'Close menu' : 'Open menu'}
            aria-expanded={open}
            aria-controls="mobile-nav"
            onClick={() => setOpen((o) => !o)}
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>

        {open && (
          <nav id="mobile-nav" className="wrap grid gap-2 pb-3 pt-1 lg:hidden" aria-label="Mobile">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end
                className={(s) => navClass(isHash(item.to) ? { isActive: false } : s, 'rounded-2xl border-ink bg-paper px-4 py-2.5 text-base')}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        )}
      </header>
      <Marquee />
    </>
  );
};

export default Header;
